import { render, staticRenderFns } from "./FuneralWishesForm.vue?vue&type=template&id=76e6764a&scoped=true&"
import script from "./FuneralWishesForm.vue?vue&type=script&lang=js&"
export * from "./FuneralWishesForm.vue?vue&type=script&lang=js&"
import style0 from "./FuneralWishesForm.vue?vue&type=style&index=0&id=76e6764a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e6764a",
  null
  
)

export default component.exports